// LayoutWithNavbar.jsx
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";

export default function LayoutWithNavbar() {
  return (
    <div className="app-layout">
      <NavBar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
